import React from 'react';

type Props = {
  size?: string | number;
  color?: string;
};

const LinkedInIcon = ({ size = 36, color = '#B3B5B6' }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={size}
    height={size}
    viewBox="0 0 36 36"
  >
    <defs>
      <path
        id="g9ca4czena"
        d="M8.504 14.413h3.899V28H8.504V14.413zm1.85-1.7h-.028C8.915 12.714 8 11.676 8 10.36 8 9.018 8.942 8 10.381 8c1.438 0 2.323 1.015 2.35 2.356 0 1.315-.912 2.358-2.377 2.358zM28 28h-4.42v-7.032c0-1.84-.692-3.095-2.212-3.095-1.163 0-1.81.847-2.11 1.665-.114.292-.096.7-.096 1.11V28h-4.38s.057-12.455 0-13.587h4.38v2.132c.259-.932 1.658-2.263 3.89-2.263 2.771 0 4.948 1.956 4.948 6.163V28z"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g>
        <g transform="translate(-1284 -132) translate(1284 132)">
          <mask id="f7ydqgdieb" fill="#fff">
            <use xlinkHref="#g9ca4czena" />
          </mask>
          <use fill={color} xlinkHref="#g9ca4czena" />
          <g fill={color} mask="url(#f7ydqgdieb)">
            <path d="M0 0H36V36H0z" />
          </g>
          <path d="M0 0H36V36H0z" />
        </g>
      </g>
    </g>
  </svg>
);

export default LinkedInIcon;
